import React from "react";

// const CreateUser = React.lazy(() => import("./CreateUser"));
const VoucherDetails = React.lazy(() => import("./VoucherDetails"));
const Index = React.lazy(() => import("./index"));
// const UserDetails = React.lazy(() => import("./UserDetails"));
// const UserUpdate = React.lazy(() => import("./UpdateUser"));

export const voucherDetailsRoutes = [
	{
		path: "/admin/voucherDetails",
		name: "Voucher Details",
		element: <Index />,
	},
	{
		path: "/admin/voucherDetails/:id",
		name: "Voucher Details",
		element: <VoucherDetails />,
	},
];
